import React from 'react';
import './kovin.css';

const MohammdNoimUddin = () => {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          

        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">International</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/Mohammd-Noim-Uddin.jpg" alt="Mohammd-Noim-Uddin" />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3>Dr. Mohammad Noim Uddin</h3>
              <div className="name-underline"></div>
            </div>
          </div>

          <div className="bio-container">
            <p className="bio">
Mohammad Noim Uddin is an optometrist and public health professional with over seven years 
of clinical, humanitarian, and leadership experience in eye care. He completed his Bachelor of 
Optometry in 2017 and later earned a Master’s degree in Public Health following the COVID-19 
period, strengthening his expertise at the intersection of clinical eye care, health systems, and 
population health. 
He began his professional career at the Autism and Child Development Centre of Maa O Shishu 
Hospital, Chittagong, where he led the optometry clinic and worked extensively with children 
with neurodevelopmental and sensory disorders. During this period, he developed a static visual 
stimulation therapy device aimed at supporting children with sensory disorders and preventing 
reflex seizures, reflecting his interest in innovation and inclusive eye care. <br /> <br />
Mr. Uddin later relocated to Cox’s Bazar to serve forcibly displaced Myanmar nationals 
(Rohingya population), providing essential eye care services in a humanitarian crisis setting. His 
work focused particularly on children, and he initiated a dedicated “Children’s Day Eye Care” 
program to improve access to pediatric eye services in refugee camps. His experience in 
emergency and low-resource settings has shaped his commitment to equity, accessibility, and 
child-centered eye health. <br /> <br />
In addition to his clinical and public health work, Mohammad Noim Uddin is actively involved 
in professional leadership. He currently serves as the General Secretary of a national optometry 
organization in Bangladesh, where he works to advance the profession, strengthen eye care 
systems, and promote eye health for all through advocacy, capacity building, and collaboration. 
<br /> <br />
He has been invited by the World Council of Optometry (WCO) and the American Optometric 
Association (AOA) to attend international optometry congresses and regularly engages in 
academic and professional development activities, including delivering presentations on 
advanced diagnostic technologies such as the Pentacam AXL. His academic and professional 
interests include public health policy, global eye health, pediatric optometry, humanitarian 
response, and health system strengthening in low- and middle-income countries.
            </p>
            <div className="bio-decoration"></div>
          </div>
        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
         <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>
          <p className="register-cta">Register Now <span>&rarr;</span><a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};

export default MohammdNoimUddin